import type { UploadFile, UploadStatus } from "@/types";
import { UPLOAD_ACCEPT, UPLOAD_MAX_FILES, UPLOAD_MAX_MB } from "@/data/formats";
import { uuidV4 } from "@/utils/uuid";
export const extensionOf = (name: string) => "." + (name.split(".").pop() || "").toLowerCase();
export const formatSize = (bytes: number) => bytes < 1024 * 1024 ? Math.max(1, Math.round(bytes / 1024)) + " KO" : (bytes / 1024 / 1024).toFixed(1) + " MO";
export function describeFile(file: File): UploadFile {
    const extension = extensionOf(file.name);
    let status: UploadStatus = "ready";
    let error: string | undefined;
    if (!file.name || file.name.includes("/") || file.name.includes("\\") || file.name.includes("\0")) {
        status = "unsupported"; error = "Nom de fichier invalide.";
    } else if (!UPLOAD_ACCEPT.includes(extension)) {
        status = "unsupported"; error = "Ce format de fichier n'est pas accepté.";
    } else if (file.size === 0 || file.size > UPLOAD_MAX_MB * 1024 * 1024) {
        status = "too-large"; error = "Fichier vide ou supérieur à " + UPLOAD_MAX_MB + " Mo.";
    }
    return { id: uuidV4(), name: file.name, size: file.size, extension, status, error, file };
}
export function acceptFiles(existing: UploadFile[], incoming: File[]): { accepted: UploadFile[]; overflow: number } {
    const room = Math.max(0, UPLOAD_MAX_FILES - existing.length);
    const dedup = incoming.filter((f) => !existing.some((e) => e.name === f.name && e.size === f.size));
    return { accepted: dedup.slice(0, room).map(describeFile), overflow: Math.max(0, dedup.length - room) };
}
